import { __ } from '@wordpress/i18n';
import { decodeEntities } from '@wordpress/html-entities';

/**
 * Get status
 * @param {boolean} confirmed
 * @param {boolean} joinable
 * @returns {JSX.Element}
 */
const CourseListItemStatus = ({ status }) => {
	if (!status) {
		return null;
	}

	return (
		<div
			className={`course-list__item__content-status course-list__item__content-status--${status[0]?.slug}`}
		>
			{decodeEntities(status[0]?.name)}
		</div>
	);
};

export default CourseListItemStatus;
